export const getDate = (string: string | null) => {
	if (!string) {
		return ''
	}
	const date = new Date(string)
	
	const timePart = string.split('T')[1]
	const isMidnight = timePart && timePart.startsWith('00:00:00')

	if (timePart && !isMidnight) {
		return date.toLocaleString()
	} else {
		return date.toLocaleDateString()
	}
}